import { render, staticRenderFns } from "./competition-1.vue?vue&type=template&id=d084f214&scoped=true&"
import script from "./competition-1.vue?vue&type=script&lang=js&"
export * from "./competition-1.vue?vue&type=script&lang=js&"
import style0 from "./competition-1.vue?vue&type=style&index=0&id=d084f214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d084f214",
  null
  
)

export default component.exports